export function buildRefLink(href: string, referral?: string): string {
  if (referral) {
    return href.includes("?")
      ? `${href}&ref=${referral}`
      : `${href}?ref=${referral}`;
  }
  return href;
}
